import * as React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import { withBaseProps } from '@topconagriculture/react-components';
const styles = (theme) => createStyles({
    button: {
        fontSize: theme.font.size.mediumSmall,
        height: 40,
        '&:hover': {
            background: 'transparent',
        },
    },
    cancel: {
        fontWeight: theme.font.weight.light,
        width: 90,
    },
});
const ModalActions = (props) => {
    const { classes, t, children, closeModal, testId = 'ModalActions' } = props;
    const closeButton = closeModal && (React.createElement(Button, { "data-testid": `${testId}-close`, onClick: closeModal, className: classNames(classes.button, classes.cancel) }, t('common:cancel')));
    return (React.createElement(DialogActions, null,
        closeButton,
        children));
};
const ComposedModalActions = compose(withBaseProps({ styles }))(ModalActions);
ComposedModalActions.displayName = 'ModalActions';
export default ComposedModalActions;
//# sourceMappingURL=ModalActions.js.map